<template>
  <div class="main">
    <div class="col-12">
      <div class="row">
        <div class="col-md-6 mt-4" v-if="$user.pacoteSocio.descpacote">
          <div class="card card_content p-3">
            <div class="d-flex justify-content-between align-items-center">
              <i class="material-icons">horizontal_split</i>
              <!-- <span class="badge badge-primary blue" target="_blank" link="no-follow">
                <i class="material-icons">add</i> Alterar Plano
              </span> -->
            </div>
            <div>
              <h6 class="text-uppercase font-weight-bolder">
                {{ $user.pacoteSocio.descpacote }}
              </h6>
              <small class="text-muted pt-2">{{ valorPacote }}</small>
            </div>
            <div class="d-flex justify-content-between align-items-center">
              <p class="success small text-uppercase fw-700">{{ situacao }}</p>
            </div>
          </div>
        </div>
        <div v-else class="col-md-12 mt-1 p-0">
          <div class="card absolute border-0">
            <h5 class="d-flex justify-content-center align-items-center">
              <i class="material-icons pr-2 py-3 blue color-blue">info</i> Você
              ainda não possui um plano ativo
            </h5>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { formata } from "../../helpers";
export default {
  name: "MeuPlano",
  components: {},
  data() {
    return {
      loading: false,
      valorPacote: formata(this.$user.planoUnitario),
      situacao: "",
    };
  },
  created() {
    if (this.$user.situacaoAssociado == "A") {
      this.situacao = "Ativo";
    } else if (this.$user.situacaoAssociado == "I") {
      this.situacao = "Inativo";
    }
  },
};
</script>
<style lang="scss" scoped>
.form_padrao {
  .form-group.flutuante {
    position: relative;
    input[type="text"],
    input[type="password"],
    input[type="email"],
    input[type="tel"],
    textarea {
      background: white;
    }
  }
  .fit-content {
    max-width: fit-content;
    padding: 0.6rem 1rem !important;
  }
}
@media screen and(max-width: 900px) {
  .fit-content {
    max-width: 100% !important;
  }
}

.card_content {
  min-height: 170px;
  display: flex;
  justify-content: space-between;
  small {
    line-height: 1.5rem;
  }
  .badge {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 6px 10px;
    cursor: pointer;
    border-radius: 0px;
    background: #05428e;
    i {
      font-size: 13px;
      color: #fecc0d;
    }
  }
  &:hover {
    transform: scale(1.05);
  }
}
</style>
